import type { IconData } from '@stacksjs/iconify-core'

export const cutter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m11.37 15.226l.023-.027l-4.617-3.832l-.002.003zm-1.286 1.533l-2.58 3.074l-7.158-.803l5.142-6.128zM7.02 14.187L4.722 12.26L13.72 1.534a4 4 0 0 1 6.128 5.143L10.85 17.4l-2.298-1.928l-1.928 2.298l-2.175-.52l2.571-3.064zm.52-2.174l3.064 2.57l7.713-9.192a2 2 0 0 0-3.064-2.571zm9.245-7.907a1 1 0 0 1 .123 1.408l-.642.766a1 1 0 1 1-1.533-1.285l.643-.766a1 1 0 0 1 1.41-.123z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cutter
